import { Route, Routes } from "react-router-dom";
import AccountabilityRouter from "./Accountability";
import MasterRouter from "./Master";
import MasterSheetV2Router from "./MasterSheetV2";
import GoodNewsRouter from "./GoodNews";
import TeamManagementRouter from "./TeamManagement";

export default function CoachingRouter() {
  return (
    <Routes>
      <Route path="/accountability/*" element={<AccountabilityRouter />} />
      <Route path="/good-news/*" element={<GoodNewsRouter />} />
      <Route path="/master/*" element={<MasterRouter />} />
      <Route path="/master-v2/*" element={<MasterSheetV2Router />} />
      <Route path="/team-management/*" element={<TeamManagementRouter />} />
    </Routes>
  );
}
